module.exports = __webpack_public_path__ + "static/media/question-circle.b31b7dc2.svg";